module.exports = __webpack_public_path__ + "media/images/teams/MILAN-10c5871c794b158971acde943f929a43.png";